import React from "react";

const GroupByFilter = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill}
            d="m30.11 16.21 1.85 1.1a.757.757 0 0 1 0 1.305l-14.293 8.482-14.293-8.482a.757.757 0 0 1 0-1.306l1.85-1.098 12.443 7.384 12.442-7.384Zm0 7.157 1.85 1.098a.757.757 0 0 1 0 1.306l-13.502 8.012c-.487.29-1.096.29-1.583 0L3.374 25.77a.757.757 0 0 1 0-1.306l1.85-1.098 12.443 7.384 12.442-7.384ZM18.458 2.217l13.5 8.012a.757.757 0 0 1 0 1.306l-14.292 8.482-14.293-8.482a.757.757 0 0 1 0-1.306l13.5-8.012a1.554 1.554 0 0 1 1.585 0Z"
        />
    </svg>
);

export default GroupByFilter;